import { AttachmentFolderPickerClientProviderType } from '../store/schema/AttachmentFolderPickerProviderType';
import { AttachmentFolderPickerProperties } from '../types/AttachmentFolderPickerProperties';
import { initializeAttachmentFolderPicker } from '../actions/publicActions';
import { orchestrator } from 'satcheljs';
import {
    fetchUploadFolder,
    getUploadFolder,
    UploadFolderMailboxType,
} from 'owa-attachments-upload-folder';
import {
    loading,
    loadingAttachmentFolderFailed,
    openAttachmentFolderPicker,
    stoppedLoading,
} from '../actions/internalActions';

orchestrator(openAttachmentFolderPicker, async actionMessage => {
    const { mailboxId, uploadFolderMailboxType } = getUploadFolderArgs(actionMessage.properties);
    await initializeFolderPicker(mailboxId, uploadFolderMailboxType);
});

orchestrator(initializeAttachmentFolderPicker, async actionMessage => {
    const { mailboxId, uploadFolderMailboxType } = getUploadFolderArgs(actionMessage.properties);
    await initializeFolderPicker(mailboxId, uploadFolderMailboxType);
});

function getUploadFolderArgs(
    properties: AttachmentFolderPickerProperties
): { mailboxId: string; uploadFolderMailboxType: UploadFolderMailboxType } {
    const { providerInfo } = properties;

    if (providerInfo.type === AttachmentFolderPickerClientProviderType.Group) {
        return {
            mailboxId: providerInfo.groupMailboxId,
            uploadFolderMailboxType: UploadFolderMailboxType.Group,
        };
    } else {
        return { mailboxId: null, uploadFolderMailboxType: UploadFolderMailboxType.User };
    }
}

async function initializeFolderPicker(
    mailboxId: string | null,
    uploadFolderMailboxType: UploadFolderMailboxType
) {
    const uploadFolder = getUploadFolder(mailboxId);
    if (!uploadFolder) {
        loading();

        try {
            const loadedUploadFolder = await fetchUploadFolder(mailboxId, uploadFolderMailboxType);

            if (!loadedUploadFolder) {
                // If the upload folder is not fetched then
                // raise the failed action
                loadingAttachmentFolderFailed();
            }
        } finally {
            stoppedLoading();
        }
    }
}
